import BaseClass from "../BaseClass.js";

export default class Recaptcha extends BaseClass {

    constructor(element) {
        super(element);

        this.config = {};

        this.jqXHR = null;
        this.widgetV2Id = null;
        this.widgetV3Id = null;
        this.formFailingHandler = null;

        this.$form = null;
        this.$submitButton = null;

        this.init();
    }

    init() {
        $.extend(
            this.config,
            {
                v2: {siteKey: this.$element.data('recaptcha-v2-sitekey')},
                v3: {
                    siteKey: this.$element.data('recaptcha-v3-sitekey'),
                    endpoint: this.$element.data('recaptcha-v3-validation-url'),
                }
            }
        );

        this.$form = this.$element.find('form').first();
        this.$submitButton = this.$form.find('[type="submit"]');

        this.$form.on('form:failing', $.proxy(this.onFormFailing, this));

        this.loadRecaptchaLibVersion('v3', $.proxy(this.runRecaptchaV3, this));
    }

    onFormFailing(event, errors) {
        if (errors != undefined) {
            if (errors['recaptcha_token'] != undefined || errors['recaptcha_token_v2'] != undefined) {
                if (this.widgetV2Id == null) {
                    this.loadRecaptchaLibVersion('v2', $.proxy(this.runRecaptchaV2, this));
                } else {
                    this.resetRecaptchaV2();
                }
            } else {
                this.loadRecaptchaLibVersion('v3', $.proxy(this.runRecaptchaV3, this));
            }
        }
    }

    loadRecaptchaLibVersion(version, callback) {
        switch (version) {
            case 'v2':
                $(document).trigger('google:recaptcha:api:load', {
                    version: 'standard',
                    render: 'explicit',
                    callback: callback
                });
                break;
            case 'v3':
                $(document).trigger('google:recaptcha:api:load', {
                    version: 'enterprise',
                    render: this.config.v3.siteKey,
                    callback: callback
                });
                break;
        }
    }

    runRecaptchaV3() {
        const mySelf = this;
        const key = this.config.v3.siteKey;
        grecaptcha.enterprise.ready(function () {
            mySelf.widgetV3Id = grecaptcha.enterprise.execute(key).then(function (token) {
                mySelf.createAssessmentV3(token);

            });
        });
    }

    runRecaptchaV2() {
        const $captchaElement = this.$form.find('[data-type="captcha-container"]');
        const captchaElement = $captchaElement.get(0);
        $captchaElement.removeClass('hidden');
        this.widgetV2Id = grecaptcha.render(captchaElement, {
            'sitekey': this.config.v2.siteKey,
            'callback': $.proxy(this.putV2TokenIntoForm, this),
            'expired-callback': $.proxy(this.resetRecaptchaV2, this)
        });

    }

    createAssessmentV3(token) {
        if (this.$form == undefined) {
            // Wird ein Modal-Fenster mit dem Login direkt wieder geschlossen, so ist $form nicht mehr vorhanden
            return;
        }
        let postData = {'recaptcha-token': token};

        this.$form.find('[name="recaptcha_token"]').val(token);
        this.$form.find('[name="recaptcha_token_v2"]').val('');
        this.$submitButton.prop('disabled', false);
    }


    putV2TokenIntoForm(token) {
        if (token.length != 0) {
            this.$form.find('[name="recaptcha_token_v2"]').val(token);
            this.$submitButton.prop('disabled', false);
        }
    }

    resetRecaptchaV2() {
        if (this.widgetV2Id !== null) {
            grecaptcha.reset(this.widgetV2Id);
        }
    }

    destroyListener() {
        if (this.jqXHR != null) {
            this.jqXHR.abort();
        }

        this.$form.off('form:failing', $.proxy(this.onFormFailing, this));
    }
}
